import { render, staticRenderFns } from "./TemplateAdjustments.vue?vue&type=template&id=4b87ce86&"
import script from "./TemplateAdjustments.vue?vue&type=script&lang=js&"
export * from "./TemplateAdjustments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports